'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Entities;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _caligramReact = require('caligram-react');

var _config = require('../config');

var _containers = require('../containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Entities(props, _ref) {
  var polyglot = _ref.polyglot;
  var disclosed = props.disclosed,
      entities = props.entities,
      entitiesTree = props.entitiesTree,
      entity = props.entity,
      handleToggleDisclosure = props.handleToggleDisclosure,
      handleToggleShowAll = props.handleToggleShowAll,
      handleToggleTreeView = props.handleToggleTreeView,
      showAll = props.showAll,
      treeView = props.treeView;


  var buildEntityLink = function buildEntityLink(entityName, en) {
    return _react2.default.createElement(
      'span',
      { className: 'entity' },
      _react2.default.createElement(
        _reactRouter.Link,
        { to: { pathname: '/evenements', query: (0, _defineProperty3.default)({ page: 1 }, entityName, en.id) } },
        en.name
      ),
      _react2.default.createElement(
        'span',
        { className: 'references' },
        en._references !== undefined ? en._references : ''
      )
    );
  };

  var Item = function Item(_ref2) {
    var item = _ref2.item;

    var liProps = { key: item.id };
    var hasChildren = item.children && item.children.length > 0;
    var isDisclosed = true;

    if (treeView && hasChildren) {
      if (_config.app.show.disclosableEntities) {
        isDisclosed = disclosed.indexOf(item.id) > -1;
        liProps.className = 'parent ' + (_config.app.show.disclosableEntities && isDisclosed ? 'expanded' : 'collapsed');
      } else {
        liProps.className = 'parent';
      }
    }

    var title = isDisclosed ? polyglot.t('event.collapseEntity') : polyglot.t('event.expandEntity');
    var icon = isDisclosed ? 'minus' : 'plus';

    return _react2.default.createElement(
      'li',
      liProps,
      buildEntityLink(entity, item),
      _config.app.show.disclosableEntities && hasChildren && treeView && _react2.default.createElement(_caligramReact.Button, { title: title, action: function action() {
          return handleToggleDisclosure(item.id);
        }, hideTitle: true, iconLeft: icon }),
      treeView && hasChildren && isDisclosed ? _react2.default.createElement(
        'ul',
        { className: 'children' },
        item.children.map(function (cEn) {
          return _react2.default.createElement(Item, { key: cEn.id + '-' + cEn.parent_id, item: cEn });
        })
      ) : ''
    );
  };

  // Open first level items by default
  if (treeView && disclosed.length === 0 && entitiesTree.length > 0) {
    handleToggleDisclosure(0);
    entitiesTree.map(function (en) {
      handleToggleDisclosure(en.id);
    });
  }

  return _react2.default.createElement(
    'div',
    { className: 'Entities' },
    _react2.default.createElement(
      _caligramReact.Page,
      { title: polyglot.t('event.entitiesAll.' + entity), layout: 'wide' },
      _react2.default.createElement(
        'p',
        null,
        polyglot.t('event.entityDescriptions.' + entity)
      ),
      _config.app.show.entityFilters && _react2.default.createElement(
        'ul',
        { className: 'filters' },
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(_caligramReact.Checkbox, { title: polyglot.t('event.showAll', { entity: entity }), action: handleToggleShowAll, checked: showAll, id: 'toggleShowAll' })
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(_caligramReact.Checkbox, { title: polyglot.t('event.treeView'), action: handleToggleTreeView, checked: treeView, id: 'toggleTreeView' })
        )
      ),
      _react2.default.createElement(
        'ul',
        { className: 'entities ' + (treeView ? 'tree' : 'flat') },
        (treeView ? entitiesTree : entities).map(function (en) {
          return _react2.default.createElement(Item, { key: en.id + '-' + en.parent_id, item: en });
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'filters' },
      _react2.default.createElement(_containers.FiltersContainer, null)
    )
  );
}

Entities.contextTypes = {
  polyglot: _react.PropTypes.object
};

Entities.propTypes = {
  disclosed: _react.PropTypes.array,
  entities: _react.PropTypes.array,
  entitiesTree: _react.PropTypes.array,
  entity: _react.PropTypes.string,
  handleToggleDisclosure: _react.PropTypes.func,
  handleToggleShowAll: _react.PropTypes.func,
  handleToggleTreeView: _react.PropTypes.func,
  showAll: _react.PropTypes.bool,
  treeView: _react.PropTypes.bool
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Entities.js
// module id = 1106
// module chunks = 0